import React from 'react'
import { Redirect, Switch } from 'react-router-dom'
import { observer } from '~/common/mobx.decorator'
import { Route } from '~/components/route'
import { careStore } from './care.store'
import { FEATURES } from '~/features'
import { PATHS } from '~/common/constants'
import { authStore } from '~/stores'

export const CareRoute = observer((props) => {
	return (
		<Switch>
			<Redirect from={PATHS.common.home} exact to={authStore.id ? PATHS.care.home : PATHS.common.authorization} />
			{careStore.features.map(({ path, code, auth }) => (
				<Route key={path} path={path} exact={path === PATHS.common.home} auth={auth} feature={code} component={FEATURES[code]} />
			))}
			<Redirect to={authStore.id ? PATHS.care.home : PATHS.common.authorization} />
		</Switch>
	)
})
